import type { Session } from '@/entities/session';

export function formatSoapNote(session?: Session): string | null {
    const note = session?.currentNote;
    if (!session || !note || note.type !== 'SOAP' || !note.content) return null;

    const { content } = note;

    return [
        `SUBJECTIVE:\n${content.subjective}`,
        '',
        `OBJECTIVE:\n${content.objective}`,
        '',
        `ASSESSMENT:\n${content.assessment}`,
        '',
        `PLAN:\n${content.plan}`,
    ].join('\n');
}
